import { useCallback, useEffect, useMemo, useState } from "react";
import TableWidget from "../../../components/tables/TableWidget";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import {
  fetchBinHistory,
  getBinStatuses,
} from "../../../redux/api/expedition.api";
import {
  binHistoryTableHeader,
  getBinTableData,
} from "./tableConfigs/binHistoryTableConfig";
import BinHistoryActionButton from "./ActionButtons/BinHistoryActionButtons";
import { dateForDatabase } from "../../../utils/dateAndTime";
import useActiveExpeditionType from "./useActiveExpeditionType";

function BinHistoryTable({ clientsNodesData }: { clientsNodesData: any[] }) {
  const dispatch = useAppDispatch();
  const type = useActiveExpeditionType();

  const {
    expedition: {
      binHistory: {
        data: { data: dataBin, total: totalBin },
        isLoading: isLoadingBin,
      },

      clients: { data: clientsData },
      binStatuses: { data: binStatusesData, isLoading: isLoadingBinStatus },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const [clientsNodesLocal, setClientsNodesLocal] = useState<any[]>([]);

  useEffect(() => {
    if (clientsNodesData.length && clientsNodesLocal?.length === 0) {
      setClientsNodesLocal(clientsNodesData);
    }
  }, [clientsNodesData, clientsNodesLocal]);

  useEffect(() => {
    dispatch(getBinStatuses());
  }, [dispatch]);

  const getHistoryTableHeaderNew = useCallback(
    (initialTableData: any[]) => {
      return initialTableData.map((item) => {
        if (item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (item.value === "client") {
          const clientsDropdown = clientsData?.data.map(
            ({ denumireClient, idClient }) => ({
              label: denumireClient,
              value: idClient || 0,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: "all" }, ...clientsDropdown],
            ...item,
          };
        }
        if (!isLoadingBinStatus && item.value === "status") {
          const binStatusesDropdown = binStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...binStatusesDropdown,
            ],
            ...item,
          };
        }

        return item;
      });
    },
    [binStatusesData, clientsData?.data, clientsNodesData, isLoadingBinStatus],
  );

  const handleBinTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      const formatDate = dateForDatabase(action.tableSearch.data_operatie);

      dispatch(
        fetchBinHistory({
          type,
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          idClient: action.tableSearch.client,
          nodDestinatie: action.tableSearch.nodDestinatie,
          status: action.tableSearch.status,
          data_operatie: formatDate,
        }),
      );
    }
  };

  const binHistoryTableHeaderNew = useMemo(
    () => getHistoryTableHeaderNew(binHistoryTableHeader),
    [getHistoryTableHeaderNew],
  );

  return (
    <TableWidget
      tableHeaderData={binHistoryTableHeaderNew}
      tableItemsData={getBinTableData(dataBin)}
      totalItems={totalBin}
      tableLoading={isLoadingBin}
      handleTableActions={handleBinTableActions}
      ActionButtonsComponent={(props: any) => (
        <BinHistoryActionButton {...props} />
      )}
      borderedRow
    />
  );
}

export default BinHistoryTable;
